interface HyperevmIconProps {
  className?: string
}

export function HyperevmIcon({ className }: HyperevmIconProps) {
  return (
    <svg viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clipPath="url(#clip0_5_25)">
        <path d="M128 0H0V128H128V0Z" fill="#072723" />
        <path
          d="M101 63.6604C101 87.7446 86.2307 95.4727 78.4489 88.5915C72.0435 82.9806 70.1378 71.1239 60.5032 69.9064C48.2748 68.3714 47.2161 84.6217 39.1697 84.6217C29.7999 84.6217 28 71.018 28 64.0309C28 56.885 30.0116 47.1454 38.0051 47.1454C47.322 47.1454 47.8513 61.0667 59.4975 60.3256C71.0906 59.5316 71.3024 45.028 78.8197 38.8349C85.3836 33.4887 101 39.2584 101 63.6604Z"
          fill="#97FCE4"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_25">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
